/**
* TODO: Document all functions
**/
export const find = (querySelector, element = document) =>
  Array.prototype.slice.call(element.querySelectorAll(querySelector))

  export const findFirst = (querySelector, element = document) =>
    Array.prototype.slice.call(element.querySelectorAll(querySelector))[0]

export const isElement = (el) => {
  try {
    // Using W3 DOM2 (works for FF, Opera and Chrome)
    // return obj instanceof HTMLElement;
    if (!(el instanceof HTMLElement)) {
      return find(el)[0].length > 0
    }
    return true
  } catch (e) {
    // Browsers not supporting W3 DOM2 don't have HTMLElement and
    // an exception is thrown and we end up here. Testing some
    // properties that all elements have. (works on IE7)
    return (typeof el === 'object') &&
      (el.nodeType === 1) && (typeof el.style === 'object') &&
      (typeof el.ownerDocument === 'object')
  }
}

export const hasClass = (element, className) => {
  if (!isElement(element)) return false

  if (element.classList) {
    return element.classList.contains(className)
  }

  return new RegExp(`(^| )${className}( |$)`, 'gi').test(element.className)
}


export const addClass = (element, className) => {
  if (!isElement(element)) return false

  if (element.classList) {
    element.classList.add(className)
  } else {
    element.className += ` ${className}`
  }
  return element
}


export const removeClass = (element, className) => {
  if (!isElement(element)) return false

  if (element.classList) {
    element.classList.remove(className)
  } else {
    element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ')
  }
  return element
}

export const exists = (selector, element = document) => element.querySelector(selector) !== null

export const findParentByClass = (element, className) => {
  let parent = element.parentNode
  if (parent !== null) {
    if (hasClass(parent, className)) {
      return parent
    }

    parent = findParentByClass(parent, className)
  }
  return parent
}


const attachListener = (element, eventName, handler) => {
  if (element.addEventListener) {
    element.addEventListener(eventName, handler, false)
  } else if (element.attachEvent) {
    element.attachEvent(`on${eventName}`, handler)
  } else {
    element[`on${eventName}`] = handler
  }
}
/**
 * adds an eventListener to an object.
 *
 * @param [NodeList|Object|String]  el  Object(s) to bind the listener
 * @param [String]  eventName Name of the event e.g. click
 * @param [function]  handler Callback function
 */
export const addListener = (el, eventName, handler) => {
  if (typeof (el) === 'string') {
    el = document.querySelectorAll(el)
    if (el.length === 1) {
      el = el[0] // if only one set it properly
    }
  }

  if (el == null || typeof (el) === 'undefined') return

  if (el.length !== undefined && el.length > 1 && el !== window) { // it's a NodeListCollection
    for (let i = 0; i < el.length; i += 1) {
      attachListener(el[i], eventName, handler)
    }
  } else { // it's a single node
    attachListener(el, eventName, handler)
  }
}


const detachListener = (element, eventName, handler) => {
  if (element.addEventListener) {
    element.removeEventListener(eventName, handler, false)
  } else if (element.detachEvent) {
    element.detachEvent(`on${eventName}`, handler)
  } else {
    element[`on${eventName}`] = null
  }
}


export const removeListener = (el, eventName, handler) => {
  if (typeof (el) === 'string') {
    el = document.querySelectorAll(el)
    if (el.length === 1) {
      el = el[0] // if only one set it properly
    }
  }

  if (el == null || typeof (el) === 'undefined') return

  if (el.length !== undefined && el.length > 1 && el !== window) { // it's a NodeListCollection
    for (let i = 0; i < el.length; i += 1) {
      detachListener(el[i], eventName, handler)
    }
  } else { // it's a single node
    detachListener(el, eventName, handler)
  }
}



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/helpers/vanilla.js